import { useCallback, useEffect, useRef, useState } from 'react';
import { useQuoteApi } from '@/features/wizard';
import type { IInvoiceUrl } from '@/types';

interface IUseFetchInvoiceReturnValue {
  fetch: () => void;
  hasError: boolean;
  invoiceUrl?: IInvoiceUrl;
  isLoading: boolean;
}

export const useFetchInvoice = (id?: string): IUseFetchInvoiceReturnValue => {
  const quoteApi = useQuoteApi();
  const [invoiceUrl, setInvoiceUrl] = useState<IInvoiceUrl | undefined>();
  const ref = useRef(false);
  const [state, setState] = useState({ isLoading: false, hasError: false });

  const fetchInvoice = useCallback(() => {
    if (id && !ref.current) {
      ref.current = true;
      setState({ isLoading: true, hasError: false });

      void (async (): Promise<void> => {
        try {
          const res = await quoteApi.getInvoice(id);
          setInvoiceUrl(res);
          setState({ isLoading: false, hasError: false });
        } catch (error) {
          console.error(error);
          setState({ isLoading: false, hasError: true });
        } finally {
          ref.current = false;
        }
      })();
    }
  }, [id, quoteApi]);

  useEffect(fetchInvoice, [fetchInvoice]);

  return { invoiceUrl, ...state, fetch: () => fetchInvoice() };
};
